import { createStore } from 'vuex';
import { permissionsListt } from "@/api/api";

export default createStore({
  state: {
    permissions: [], // 初始化权限数组
    loading: false,
  },
  getters: {
    permissions: state => state.permissions
  },
  mutations: {
    setPermissions(state, permissions) {
      state.permissions = permissions;
    }
  },
  actions: {
    loadPermissionsFromLocalStorage({ commit }) {
      const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
      commit("setPermissions", permissions);
    },
    async fetchPermissions({ commit }) {
      try {
        const response = await permissionsListt();
        console.log(response);
        if (response.data && response.data.a) {
          commit("setPermissions", response.data.a);
          localStorage.setItem("permissions", JSON.stringify(response.data.a));
        } else {
          console.error("权限数据格式不正确");
        }
      } catch (error) {
        console.error("获取权限失败:", error);
      }
    },
  },
  modules: {}
});
